import React from "react";
import { X, FileText } from "lucide-react";

const FilePreview = ({ fieldName, preview, file, existingFile, onRemove }) => {
  if (!preview && !existingFile) return null;

  if (file) {
    if (file.type.startsWith("image/")) {
      return (
        <div className="relative inline-block mt-2">
          <img
            src={preview}
            alt="Preview"
            className="h-16 w-16 object-cover rounded-md border"
          />
          <button
            type="button"
            onClick={() => onRemove(fieldName)}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 text-xs"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      );
    } else {
      return (
        <div className="relative inline-block mt-2">
          <div className="flex items-center gap-2 p-2 border rounded-md bg-blue-50">
            <FileText className="h-6 w-6 text-blue-600" />
            <span className="text-sm truncate">{file.name}</span>
            <button
              type="button"
              onClick={() => onRemove(fieldName)}
              className="text-red-500 hover:text-red-700"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      );
    }
  }

  if (existingFile) {
    return (
      <div className="relative inline-block mt-2">
        <div className="flex items-center gap-2 p-2 border rounded-md bg-green-50">
          <FileText className="h-4 w-4 text-green-600" />
          <a
            href={existingFile}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-green-700 hover:underline truncate"
          >
            View Uploaded <br /> Document
          </a>
          <button
            type="button"
            onClick={() => onRemove(fieldName)}
            className="text-red-500 hover:text-red-700"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default FilePreview;
